<template>
  <div class="max-width">
    <div class="page">
      <div class="subs">
        <router-link to="/" class="subs__links">Home</router-link>
        <span>Privacy Policy</span>
      </div>

      <h1 class="section__title">Privacy Policy</h1>

      <div class="page__content">
        <h2>Introduction</h2>

        <p>Thank you for visiting Almost Perfect Studio. We create products to enhance your website building experience. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.</p>

        <h2>Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, and other details you provide when contacting us or signing up for support.</li>
          <li><strong>Usage Data:</strong> Information on how you interact with our website, including pages visited, clicks, and device information.</li>
          <li><strong>Cookies & Tracking:</strong> We use cookies and similar technologies to improve your experience and analyze site performance.</li>
        </ul>

        <h2>How We Use Your Information</h2>

        <p>We use your information to:</p>
        <ul>
          <li>Provide support and assistance through our Help Center</li>
          <li>Respond to inquiries and requests</li>
          <li>Improve our website and services</li>
          <li>Send updates or newsletters if you have opted in</li>
        </ul>

        <h2>Sharing of Information</h2>
        <p>We do not sell or rent your personal information. We may share your data:</p>
        <ul>
          <li>With third-party service providers to help us operate the website and provide support.</li>
          <li>If required by law, legal processes, or to protect Almost Perfect Studio’s rights.</li>
        </ul>

        <h2>Data Security</h2>

        <p>We take reasonable measures to protect your information against unauthorized access, alteration, disclosure, or destruction.</p>

        <h2>Your Rights</h2>

        <p>Depending on your location, you may have rights regarding your personal data, including:</p>
        <ul>
          <li>Accessing your data.</li>
          <li>Requesting corrections or deletion.</li>
          <li>Withdrawing consent for communications.</li>
        </ul>
        <p>To exercise your rights, contact us via our <a href="https://ashstonestudios.zendesk.com/hc/en-us/articles/32061722600082-Get-Support" target="_blank">Support page</a>.</p>
      </div>
    </div>
  </div>
</template>
<script setup>
</script>
